module.exports = __webpack_public_path__ + "img/3.cd3ae5a7.jpg";